import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { ToggleEventType, ToggleEventNameType, ToggleEventService } from '../../../services/toggle-event.service';
import { TraceService } from '../../../services/trace.service';
import { A11yModule } from '@angular/cdk/a11y';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TraceImportComponent } from '../trace-import/trace-import.component';
// import { TraceViewToolsComponent } from '../trace-view-tools/trace-view-tools.component';


@Component({
  selector: 'tt-trace-xsmall-dialog-import',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    TraceImportComponent
],
  templateUrl: './trace-xsmall-dialog-import.component.html',
  standalone: true
})
export class TraceXsmallDialogImportComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription;
  // @ViewChild('TraceViewToolsComponent') TraceViewToolsComponent: TraceViewToolsComponent;
  constructor(
    private _toggleEventService: ToggleEventService,
    private _traceService: TraceService,
    private _bottomSheet: MatBottomSheet
  ) { }
  ngOnInit(): void {
    this._subscriptions = new Subscription();

    this._subscriptions.add(
      this._toggleEventService.emitter$.subscribe((toggleEvent: ToggleEventType) => {
        //we normally get a close event here when other parts of the application called method traceService.openTraceTab with parameter TraceDrawerType.CLOSE_AND_VIEW_ROUTE
        //trace-histo-import/FILE_IMPORT is normally followed by trace/CLOSE_COMMAND; we could add trace-histo-import/FILE_IMPORT here to close the import window quicker
        if (
          /*(toggleEvent.forwardedFor === 'trace-histo-import' &&  toggleEvent.eventName === ToggleEventNameType.FILE_IMPORT) || */
          (toggleEvent.forwardedFor === 'trace' &&  toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND)
        ) {
          this._traceService.closeImportDialog();
          // console.log('.............. close import .................')
          // if (!this.once){
          //          this.showRouteTools();
          //  this.once=true
          // }

          // this._traceService.openViewDialog();
        }
      })
    );
  }
  // once = false;
  //   showRouteTools(): void {
  //     console.log('//showroutetools')
  //     this._bottomSheet.open(TraceViewToolsComponent,
  //       {
  //         hasBackdrop: false
  //       });
  //       // this._traceService.openViewDialog();
  //   };

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}